<template>
  <div :class="['main',type]">
   <!-- <p style="position: absolute;z-index: 99;color: aliceblue;background: #000;">{{ device }} {{ size }} {{ rotate }} {{ iframeStyle }} {{ classType }}</p>  -->
    <div :class="['demo', device]" :style="size">
      <img class="demologo" :class="classType" :src="demologo" v-if="this.type == 'minigame'">
      <div class="iframe" :style="rotate">
        <iframe :src="url" :class="classType" :style="iframeStyle" frameborder="0"></iframe>
      </div>
      <div class="device" v-if="device === 'desktop'&&type!='aeonbetgame'" :class="classType"></div>
    </div>
  </div>
</template>

<script>
  const demologo = require('@/assets/demologo.png');
  export default {
    name: "demo",
    data: function () {
      return {
        demologo: demologo,
        type: this.$route.params.type,
        width: this.$route.params.width,
        height: this.$route.params.height,
        device: this.$route.params.device,
        gameCode: this.$route.params.gameCode,
        uId: this.$route.params.uId,
        uiType: this.$route.params.uiType,
        lang: this.$route.params.lang,
        wWidth: window.innerWidth,
        wHeight: window.innerHeight,
      }
    },
    computed: {
      classType() {
        switch (this.type) {
          case 'aeonbetgame':
            return [
              'ui-' + this.uiType, 'de-' + this.device
            ]
            break;
          case 'aresbetgame':
            return [
              'ui-' + this.uiType, 'de-' + this.device
            ]
            break;
          case 'minigame':
            return [
              'ui-' + this.uiType, 'de-' + this.device
            ]
            break;
          case 'marblegame':
            return [
              'ui-horizontal-mobile', 'de-' + this.device
            ]
            break;
          case 'lottogame':
            return [
              'ui-horizontal-mobile', 'de-' + this.device
            ]
            break;
        }

      },
      game() {
        return this.$dataManager.findGameByGid(this.$route.params.gameCode)
      },
      size() {
        if (this.type != 'aeonbetgame') {
          if (this.device === 'desktop') {
            return {
              width: this.width + 'px',
              height: this.height + 'px',
            }
          } else {
            return {
              width: '100%',
              height: '100%',
              transform: (this.wWidth < this.wHeight) ? 'rotate(0deg)' : 'rotate(0deg)',
            }
          }
        }
      },
      rotate() {
        if (this.device !== 'desktop') {
          return {
            transform: (this.wWidth < this.wHeight) ? 'rotate(0deg)' : 'rotate(0deg)',
          }
        }
      },
      iframeStyle() {
        switch (this.type) {
          case 'aeonbetgame':
            if (this.device === 'desktop') {
              var width = this.uiType == 'mobile' ? parseInt(this.width) * 0.855 : parseInt(this.width) * 0.505
              var height = this.uiType == 'mobile' ? width / 2.11 : width / 1.09
              return {
                // width: width + 'px',
                // height: height + 'px',
                // left: this.uiType == 'mobile' ? '7%' : '26%',
                // top: this.uiType == 'mobile' ? '10%' : '9%',
                width: '90%',
                height: '50%',
              }
            } else {
              var width = (this.wWidth < this.wHeight) ? this.wHeight * 0.55 : this.wWidth * 0.9
              var height = this.uiType == 'mobile' ? width / 2.11 : width / 1.09
              return {
                // top: '0%',
                // left: this.device == 'mobile' ? '0%' : this.uiType == 'mobile' ? '5%' : '26%',
                // width: width + 'px',
                // height: height + 'px',
                width: '100%',
                height: '90%',
              }
            }
            break;
          case 'aresbetgame':
            if (this.device === 'desktop') {
              var width = this.uiType == 'mobile' ? parseInt(this.width) * 0.855 : parseInt(this.width) * 0.505
              var height = this.uiType == 'mobile' ? width / 2.11 : width / 1.09
              return {
                width: width + 'px',
                height: height + 'px',
                left: this.uiType == 'mobile' ? '7%' : '26%',
                top: this.uiType == 'mobile' ? '10%' : '9%',
              }
            } else {
              var width = (this.wWidth < this.wHeight) ? this.wHeight * 0.55 : this.wWidth * 0.9
              var height = this.uiType == 'mobile' ? width / 2.11 : width / 1.09
              return {
                top: '0%',
                left: this.device == 'mobile' ? '0%' : this.uiType == 'mobile' ? '5%' : '26%',
                width: width + 'px',
                height: height + 'px',
              }
            }
            break;
          case 'minigame':
            if (this.device === 'desktop') {
              var width = this.uiType == 'mobile' ? parseInt(this.width) * 0.855 : parseInt(this.width) * 0.505
              var height = this.uiType == 'mobile' ? width / 2.11 : width / 1.09
              return {
                width: width + 'px',
                height: height + 'px',
                left: this.uiType == 'mobile' ? '7%' : '26%',
                top: this.uiType == 'mobile' ? '10%' : '9%',
              }
            } else {
              var width = (this.wWidth < this.wHeight) ? this.wHeight * 0.55 : this.wWidth * 0.9
              var height = this.uiType == 'mobile' ? width / 2.11 : width / 1.09
              return {
                top: '0%',
                left: this.device == 'mobile' ? '0%' : this.uiType == 'mobile' ? '5%' : '26%',
                width: width + 'px',
                height: height + 'px',
              }
            }
            break;
          case 'marblegame':
            if (this.device === 'desktop') {
              var width = this.width * 0.79
              var height = width * 1.7
              return {
                top: '15%',
                left: '10%',
                width: width + 'px',
                height: height + 'px',
              }
            }else{
              var width = this.wWidth * 0.9
              var height = width * 1.3
              return {
                width: width + 'px',
                height: height + 'px',
              }
            }
            break;
          case 'lottogame':
            if (this.device === 'desktop') {
              var width = this.device !== 'mobile' ? this.width * 0.79 : this.width * 0.78
              var height = width * 1.7
              return {
                top: '15%',
                left: '10%',
                width: width + 'px',
                height: height + 'px',
              }
            }
            break;
        }
      },
      url() {
        switch (this.game.login.type) {
          case 'random':
            return this.game.linkUrl + '?demo=1&uCId=1&gameCode=' + this.gameCode + '&uId=' + this.uId + '&uiType=' + this.uiType + '&Lang=' + this.lang
            break;
          case 'account':
            var acc = this.randomAccount()
            return this.game.linkUrl + '?acc=' + acc.acc + '&pwd=' + acc.pwd + '&Lang=' + this.lang
            break;
        }
      }
    },
    methods: {
      randomAccount: function () {
        var i = this.getRandom(0, this.$dataManager.getters.accounts.length)
        return this.$dataManager.getters.accounts[i]
      },
      getRandom: function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      getWidth: function () {
        this.wWidth = window.innerWidth
        this.wHeight = window.innerHeight
      },
    },
    mounted: function () {
      var $this = this
      $this.getWidth()
      window.onresize = () => {
        return (() => {
          // $this.getWidth()
        })()
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../style/demo';
</style>
